/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/performance/loggers/task"/>

import { last } from "underscore";
import { when } from "jquery";
import { trackEvent } from "Core/Medius.Core.Web/Scripts/appInsights";
import * as timing from "Core/Medius.Core.Web/Scripts/Medius/lib/performance";

let activeLoadMeasurement: any;

function getReadableDocumentType(documentTypeName: string) {
    return last(documentTypeName.split('.'));
}

export function startLoadMeasurement() {
    activeLoadMeasurement = timing.now();
    return activeLoadMeasurement;
}

export function handle(bindingContext: any, context: any) {
    stopLoadMeasurement(bindingContext, context);
}

export function stopLoadMeasurement(bindingContext: any, context: any) {
    const taskContext = context.get('task-handling-context');
    const stepName = !!taskContext ? taskContext.workflowStep : 'no-context';
    const documentType = !!taskContext ? getReadableDocumentType(taskContext.documentType) : 'no-context';
    const taskId = !!taskContext ? taskContext.taskId : 0;
    const measurement = activeLoadMeasurement;

    when(bindingContext.$loadComplete).then(() => {
        if (measurement) {
            trackEvent({
                name: "Load document",
                properties: {
                    documentType: documentType,
                    stepName: stepName,
                    taskId: taskId,
                    time: timing.now() - measurement,
                }
            });
        }
    });


    activeLoadMeasurement = null;
}